// sidebarStore.ts
import { create } from "zustand";

interface SidebarState {
  refreshKey: number;
  coffeeCallNotification: any;
  regularCallNotification: any;
  groupCallInvitation: any;
  groupCallNotification: any;
  callConfirmation: any;
  callRemainder: any;
  missedGroupCall: any;
  setCoffeeCallNotification: (notif: any) => void;
  setRegularCallNotification: (notif: any) => void;
  setGroupCallInvitation: (notif: any) => void;
  setGroupCallNotification: (notif: any) => void;
  setCallConfirmation: (notif: any) => void;
  setCallRemainder: (notif: any) => void;
  setMissedGroupCall: (notif: any) => void;
}

export const useSidebarStore = create<SidebarState>((set) => ({
  refreshKey: 0,
  coffeeCallNotification: null,
  regularCallNotification: null,
  groupCallInvitation: null,
  groupCallNotification: null,
  callConfirmation: null,
  callRemainder: null,
  missedGroupCall: null,
  setCoffeeCallNotification: (notif) => set({ coffeeCallNotification: notif }),
  setRegularCallNotification: (notif) =>
    set({ regularCallNotification: notif }),
  setGroupCallInvitation: (notif) => set({ groupCallInvitation: notif }),
  setGroupCallNotification: (notif) => set({ groupCallNotification: notif }),
  setCallConfirmation: (notif) => set({ callConfirmation: notif }),
  setCallRemainder: (notif) => set({ callRemainder: notif }),
  setMissedGroupCall: (notif) => set({ missedGroupCall: notif }),
}));
